import Modal from '@material-ui/core/Modal'
import React, { FC, useState } from 'react'

import { CrossIcon } from 'uiKit/icons/CrossIcon'

import * as S from './ConfirmDeleteModal.style'
import { CButton } from '../CButton'

const DEFAULT_TITLE = 'Are you sure you want to delete?'
const DEFAULT_SUBTITLE = 'All data will be permanently deleted.'

type ConfirmDeleteModalProps = {
  open: boolean
  title?: string
  subtitle?: string
  onClose: () => void
  onDelete: () => Promise<any>
}

export const ConfirmDeleteModal: FC<ConfirmDeleteModalProps> = ({
  open,
  title = DEFAULT_TITLE,
  subtitle = DEFAULT_SUBTITLE,
  onClose,
  onDelete,
}) => {
  const [loading, setLoading] = useState(false)
  const handleDelete = async () => {
    try {
      setLoading(true)
      await onDelete()
    } catch (e) {
      setLoading(false)
      throw e
    }
  }

  if (!open) return null

  return (
    <Modal open onClose={onClose}>
      <S.Container>
        <S.Title>{title}</S.Title>
        {subtitle && <S.SubTitle>{subtitle}</S.SubTitle>}
        <S.IconWrap onClick={onClose}>
          <CrossIcon color={'var(--color-spun-pearl-grey)'} />
        </S.IconWrap>
        <S.ButtonsWrap>
          <CButton label="Cancel" color="primary" disabled={loading} onClick={onClose} />
          <CButton label="Delete" color="danger" disabled={loading} onClick={handleDelete} />
        </S.ButtonsWrap>
      </S.Container>
    </Modal>
  )
}
